import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../pages_css/Projects.css";
import ticTacToeImg from "../assets/images/projects_screenshots/tictactoe.png";
import ticTacToeMobileImg from "../assets/images/projects_screenshots/Tic-Tac-Toe_mobile.png";
import flipkicksImg from "../assets/images/projects_screenshots/flipkicks.png";
import flipkicksMobileImg from "../assets/images/projects_screenshots/Flipkicks_mobile.png";
import wednesdayImg from "../assets/images/projects_screenshots/wednesday.webp";
import wednesdayMobileImg from "../assets/images/projects_screenshots/wednesday_mobile.webp";
import calculatorImg from "../assets/images/projects_screenshots/calc.png";
import cafeCozyImg       from "../assets/images/projects_screenshots/CafeCozy.png";
import cafeCozyMobileImg from "../assets/images/projects_screenshots/Cafecozy_mobile.png";
import trendiesImg       from "../assets/images/projects_screenshots/Trendies.png";
import trendiesMobileImg from "../assets/images/projects_screenshots/Trendies_mobile.png";
import bsfSchoolImg       from "../assets/images/projects_screenshots/bsfschool.png";
import bsfSchoolMobileImg from "../assets/images/projects_screenshots/bsfschool_mobile.png";
import gitlensImg from "../assets/images/projects_screenshots/Gitlensai.png";
import gitlensMobileImg from "../assets/images/projects_screenshots/Gitlensai_mobile.png";

const projectsData = [
  {
    id: 1,
    category: "Featured Projects",
    title: "GITLENS AI",
    year: "2026",
    image: gitlensImg,
    imgW: 1920, imgH: 1080,
    mobileImage: gitlensMobileImg,
    mobileImgW: 390, mobileImgH: 844,
    path: "/projects/gitlens-ai",
    desc: "AI-powered GitHub analytics with sleep heatmap and developer comparisons.",
    fullDesc: "Type any GitHub username and get insights their profile never shows: an AI-written summary via GPT-OSS 120B, a 24-hour sleep heatmap built from real commit timestamps, coding personality detection, and head-to-head developer comparisons.",
    pills: ["Next.js", "TypeScript", "Groq AI", "GitHub API", "Clerk Auth", "Framer Motion"],
  },
  {
    id: 2,
    category: "Featured Projects",
    title: "FILP-KICKS",
    year: "2026",
    image: flipkicksImg,
    imgW: 1512, imgH: 812,
    mobileImage: flipkicksMobileImg,
    mobileImgW: 390, mobileImgH: 844,
    path: "/projects/flipkicks",
    desc: "Flip-Kicks is a brand to resell the shoes.",
    fullDesc: "A high-fidelity sneaker resale landing page combining premium visual branding, marketplace trust signals, and a custom JavaScript carousel, designed around authenticity, security, and a strong visual identity.",
    pills: ["HTML", "CSS", "JavaScript", "Figma", "Glassmorphism"],
  },
  {
    id: 3,
    category: "Shopify",
    title: "Trendies Smoke",
    year: "2025",
    image: trendiesImg,
    imgW: 1920, imgH: 1080,
    mobileImage: trendiesMobileImg,
    mobileImgW: 390, mobileImgH: 844,
    path: "/projects/trendies-smoke",
    desc: "Shopify e-commerce store for a Vancouver smoke and vape retailer.",
    fullDesc: "A full Shopify build for Trendies Smoke — 200+ products across 20+ brands, a custom 19+ age verification gate, schema-driven homepage sections, and a metafield architecture that keeps the client fully in control without touching code.",
    pills: ["Shopify", "Liquid", "Dawn Theme", "CSS3", "JavaScript", "Metafields"],
  },
  {
    id: 4,
    category: "Featured Projects",
    title: "TIC-TAC-TOE",
    year: "2026",
    image: ticTacToeImg,
    imgW: 1623, imgH: 1011,
    mobileImage: ticTacToeMobileImg,
    mobileImgW: 390, mobileImgH: 844,
    path: "/projects/tic-tac-toe",
    desc: "A modern Tic-Tac-Toe game with Groq AI integration.",
    fullDesc: "A modern Tic-Tac-Toe experience with a cyber-neon UI, multiple game modes, local score tracking, and an AI-powered opponent built on the Groq API, designed to make gameplay smarter and more dynamic.",
    pills: ["HTML", "CSS", "JavaScript", "Groq API", "Figma"],
  },
  {
    id: 5,
    category: "Featured Projects",
    title: "Cafe Cozy",
    year: "2025",
    image: cafeCozyImg,
    imgW: 1895, imgH: 1017,
    mobileImage: cafeCozyMobileImg,
    mobileImgW: 390, mobileImgH: 844,
    path: "/projects/cafe-cozy",
    desc: "A premium cafe SPA built with React and custom CSS.",
    fullDesc: "A luxury single-page marketing site for a fictional Vancouver cafe, built to demonstrate agency-quality front-end work: a React component architecture, a hand-built CSS design system, data-driven rendering, and ten fully custom editorial sections — no frameworks, no templates.",
    pills: ["React", "Vite", "Custom CSS", "CSS Grid", "Framer Motion"],
  },
  {
    id: 6,
    category: "Client Work",
    title: "BSF Senior Secondary School",
    year: "2024",
    image: bsfSchoolImg,
    imgW: 1920, imgH: 1080,
    mobileImage: bsfSchoolMobileImg,
    mobileImgW: 390, mobileImgH: 844,
    path: "/projects/bsf-school",
    desc: "Institutional website built during internship at Webdox for a BSF campus school in Jalandhar.",
    fullDesc: "A full multi-page institutional website for BSF Senior Secondary School, Jalandhar Cantt — built during a web development internship at Webdox. Covers admissions, fee structure, staff directory, labs, sports facilities, and a contact page with Google Maps embed.",
    pills: ["HTML5", "CSS3", "JavaScript", "PHP", "Responsive Design", "Google Maps"],
  },
  {
    id: 7,
    category: "Featured Projects",
    title: "WEDNESDAY",
    year: "2025",
    image: wednesdayImg,
    imgW: 1440, imgH: 900,
    mobileImage: wednesdayMobileImg,
    mobileImgW: 292, mobileImgH: 619,
    mobileImgPosition: "center center",
    path: "/projects/wednesday",
    desc: "An interactive 3D animation inspired by the Wednesday web series.",
    fullDesc: "An immersive web experience inspired by the Wednesday series, built entirely with CSS 3D transforms, pseudo-elements, and keyframe animations to create cinematic hover reveals with no JavaScript.",
    pills: ["HTML", "CSS", "3D Transforms", "Photoshop"],
  },
  {
    id: 8,
    category: "Featured Projects",
    title: "CALCULATOR",
    year: "2026",
    image: calculatorImg,
    imgW: 1919, imgH: 1017,
    path: "/projects/calculator",
    desc: "A scientific calculator with math.js and keyboard support.",
    fullDesc: "A functional scientific calculator web app built to handle advanced mathematical expressions using math.js, with a structured 5-column grid interface inspired by real calculator hardware and full keyboard support.",
    pills: ["HTML", "CSS", "JavaScript", "math.js"],
  },
];

const filters = ["All", "Featured Projects", "Shopify", "Client Work"];

const GridIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <rect x="1" y="1" width="7" height="7" rx="1.5" fill="currentColor" />
    <rect x="10" y="1" width="7" height="7" rx="1.5" fill="currentColor" />
    <rect x="1" y="10" width="7" height="7" rx="1.5" fill="currentColor" />
    <rect x="10" y="10" width="7" height="7" rx="1.5" fill="currentColor" />
  </svg>
);

const ListIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <rect x="1" y="2" width="16" height="4" rx="1.5" fill="currentColor" />
    <rect x="1" y="7" width="16" height="4" rx="1.5" fill="currentColor" />
    <rect x="1" y="12" width="16" height="4" rx="1.5" fill="currentColor" />
  </svg>
);

function Projects() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [layout, setLayout] = useState("list");

  const filtered =
    activeFilter === "All"
      ? projectsData
      : projectsData.filter((p) => p.category === activeFilter);

  const cardClass = (base) =>
    layout === "list" ? `${base} project-card--list` : base;

  const renderCard = (project, index) => {
    const isGrid    = layout === "grid";
    const src       = isGrid && project.mobileImage ? project.mobileImage        : project.image;
    const w         = isGrid && project.mobileImage ? project.mobileImgW         : project.imgW;
    const h         = isGrid && project.mobileImage ? project.mobileImgH         : project.imgH;
    const imgPos    = isGrid && project.mobileImgPosition ? project.mobileImgPosition : undefined;

    const isList = layout === "list";

    const inner = (
      <>
        <div className="project-image-wrap">
          {src ? (
            <img src={src} alt={project.title} width={w} height={h} style={imgPos ? { objectPosition: imgPos } : undefined} />
          ) : (
            <div className="project-image-placeholder">
              <span>{project.title}</span>
            </div>
          )}
        </div>
        <div className="project-card-overlay" />
        <div className="project-info">
          <div className="project-meta">
            <span className="project-category">{project.category}</span>
            <span className="project-year">{project.year}</span>
          </div>
          <h3>{project.title}</h3>
          <p>{isList && project.fullDesc ? project.fullDesc : project.desc}</p>
          {isList && project.pills && (
            <div className="project-pills">
              {project.pills.map((pill) => (
                <span key={pill} className="project-pill">{pill}</span>
              ))}
            </div>
          )}
        </div>
      </>
    );

    return project.path ? (
      <Link
        key={project.id}
        to={project.path}
        className={cardClass("project-card project-card-link")}
        style={{ "--card-delay": `${index * 120}ms` }}
      >
        {inner}
      </Link>
    ) : (
      <div
        key={project.id}
        className={cardClass("project-card")}
        style={{ "--card-delay": `${index * 120}ms` }}
      >
        {inner}
      </div>
    );
  };

  return (
    <section className="projects-page">
      <Link to="/" className="back-home">← Back to home</Link>

      <div className="projects-header">
        <h1>PROJECTS</h1>
        <span className="underline"></span>
        <p>Frontend and full-stack builds, backed by UI/UX-driven design.</p>
      </div>

      <div className="projects-toolbar">
        <div className="filters">
          {filters.map((f) => (
            <button
              key={f}
              className={activeFilter === f ? "active" : ""}
              onClick={() => setActiveFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="layout-toggle">
          <button
            className={layout === "grid" ? "active" : ""}
            onClick={() => setLayout("grid")}
            aria-label="Grid view"
            title="Grid view"
          >
            <GridIcon />
          </button>
          <button
            className={layout === "list" ? "active" : ""}
            onClick={() => setLayout("list")}
            aria-label="List view"
            title="List view"
          >
            <ListIcon />
          </button>
        </div>
      </div>

      <div className={`projects-grid${layout === "list" ? " projects-grid--list" : ""}`}>
        {filtered.map(renderCard)}
      </div>
    </section>
  );
}

export default Projects;
